import autoload from "./autoload";
import auth from "./mixins/auth";
import initDom from "./mixins/init_dom";
import cart from "./mixins/cart";
import MainUserAccount from "./components/user/MainUserAccount";

autoload();

window.app = new Vue({
  el: "#vue-app",

  mixins: [auth, initDom, cart],

  components: { MainUserAccount },

  data: {
    showFooter: true,
    currentModalView: "signin",
    isResetView: window._PR?.reset ?? false,
    carriedOverMessage: window._PR?.carried_over_message || undefined,
  },

  computed: {
    totalCartItems() {
      if (this.cartItems) {
        return this.cartItems.length;
      }

      return 0;
    },
  },

  mounted() {
    this.$on("change-modal", function (view) {
      this.currentModalView = view;
    });

    if (this.isResetView) {
      this.currentModalView = "reset";
      $("#logInLink").trigger("click");
    }
  },
});
